/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as eventV1 from "./keyapis_event_event_v1.pb"

/**
 * События для сервиса событий
 */

/**
 * Задача создание события.
 * Очередь key.event.create
 */
export type CreateTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Событие
   */
  event: eventV1.EventRequestDto
}
/**
 * Задача создание события.
 * Очередь key.event.create
 */
export type CreateTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Событие
   */
  event: eventV1.EventResponseDto
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Задача создание события.
   * Очередь key.event.create
   */
  "CreateTask": {
    "kind": "class",
    "text": "Задача создание события.\nОчередь key.event.create",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Событие
       */
      "event": {
        "type": "Event",
        "text": "Событие",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
}